import axios from 'axios'
import { useAuthStore } from '@/shared/store/useAuthStore.ts'

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_ENGINE_URL ?? '/api',
  withCredentials: false,
})

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('ludus.token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// A 401 means the token is missing, expired or revoked — drop it so the app's
// gate falls back to the login screen instead of leaving the operator on a page
// where every request quietly fails. Directus access tokens do expire, so this
// is the ordinary end of a session rather than an error path.
apiClient.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) useAuthStore.getState().logout()
    return Promise.reject(error)
  },
)
